import * as React from 'react';

import {AiHomepageHeader} from 'shells/ai-homepage/text/ai-homepage-header';
import {ScrollTriggeredAnimateIn} from 'shells/animation/scroll-triggered-animate-in';

import {DefaultReportsSubsection} from './default-reports-subsection';
import {HelpSection} from './help-section';
import {getReportsForGrouping} from './reports-list';
import type {DefaultReportGrouping} from './types';

import styles from './default-reports.module.css';

const GROUPINGS: DefaultReportGrouping[] = ['lead', 'effort', 'other'];

export function DefaultReportsSection(): React.ReactElement {
    return (
        <div className={styles['default-reports-container']}>
            <AiHomepageHeader text='Browse all of Nutshell’s reports' color='dark' />
            <div className={styles['sections-container']}>
                {GROUPINGS.map((grouping) => {
                    const reports = getReportsForGrouping(grouping);

                    return (
                        // @ts-expect-error
                        <ScrollTriggeredAnimateIn key={grouping}>
                            <DefaultReportsSubsection grouping={grouping} reports={reports} />
                        </ScrollTriggeredAnimateIn>
                    );
                })}

                {/* @ts-expect-error */}
                <ScrollTriggeredAnimateIn>
                    <HelpSection />
                </ScrollTriggeredAnimateIn>
            </div>
        </div>
    );
}
